import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  ShopByPlateForm,
  VehicleSwitcher,
  VehicleConfiguratorStyles
} from 'src/components/VehicleConfigurator'
import VehicleEditorButtons from '../../../VehicleEditorButtons'

const { Title } = VehicleConfiguratorStyles

const LicenceEditor = ({ handleSwitch, formName, handleSubmit, ...props }) =>
  <Fragment>
    <Title data-at-licence-editor-title>Enter Your License Plate Number</Title>
    <ShopByPlateForm { ...props } form={ formName } onSubmit={ handleSubmit } >
      <VehicleEditorButtons />
    </ShopByPlateForm>
    <VehicleSwitcher handleSwitch={ handleSwitch } />
  </Fragment>

export default LicenceEditor

LicenceEditor.propTypes = {
  formName: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleSwitch: PropTypes.func
}
